import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { trackPageView } from "@/lib/analytics"

/**
 * Envoie un page_view GA4 à chaque changement de route (SPA).
 * Sans effet si l'analytics n'est pas chargé (consentement non donné).
 */
export function usePageTracking() {
  const location = useLocation()

  useEffect(() => {
    trackPageView(location.pathname + location.search)
  }, [location.pathname, location.search])
}
